import api from '@/services/api';

export default {
  async getGlAccounts(budgetIterationId, glAccountType, includeLockInfo) {
    try {
      var url = (budgetIterationId ? `/GLAccounts/${glAccountType || 'All'}/${budgetIterationId || ''}` : `/GLAccounts/${glAccountType || 'All'}`) +
        (includeLockInfo ? '?includeLockInfo=true' : '');
      let response = await api.get(url);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  }
}
